
        
import UserHomeEventsComponent from '../Components/UserHomeEventsComponent';
import UserHomePlacesComponent from '../Components/UserHomePlacesComponent';
import UserHomeMyPlacesComponent from '../Components/UserHomeMyPlaceComponent';
import { useParams } from 'react-router-dom';

function UserHome() {
    const {showPage} = useParams()

    return (
        <div className='flex flex-column lg:flex-row gap-2 flex-1 w-full'>
            <div className='flex flex-1 w-full'>
                {showPage === 1 ? <UserHomeEventsComponent /> : showPage === 2 ? <UserHomePlacesComponent /> : <UserHomeMyPlacesComponent />}
            </div>
        </div>
    )
}

export default UserHome